import { selectCurrentCompleteness } from 'legacy/lut/features/partner360/completeness'
import { selectPartnerAccess } from 'legacy/lut/features/partner360/configuration'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getCompletenessItems } from 'partner360/entities/partnerCompleteness'

export const useCompletenessItems = () => {
  const completeness = useSelector(selectCurrentCompleteness)
  const { isDistributor } = useSelector(selectPartnerAccess)

  const completenessItems = useMemo(
    () => getCompletenessItems(completeness, isDistributor),
    [completeness, isDistributor]
  )

  return {
    completenessItems,
    totalPercentage: completeness ? completeness.total : 0,
  }
}
